import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconAirpodCase: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconAirpodCase"><Path d="M7 3C4.79086 3 3 4.79086 3 7V9H21V7C21 4.79086 19.2091 3 17 3H7Z" fill="currentColor"/><Path fillRule="evenodd" clipRule="evenodd" d="M21 10H3V17C3 19.2091 4.79086 21 7 21H17C19.2091 21 21 19.2091 21 17V10ZM12 13.5C12.4142 13.5 12.75 13.1642 12.75 12.75C12.75 12.3358 12.4142 12 12 12C11.5858 12 11.25 12.3358 11.25 12.75C11.25 13.1642 11.5858 13.5 12 13.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconAirpodCase;
